import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const RoutingSubRoutes = () => (
  <ComponentDocs
    name="<Routing.SubRoutes/>"
    entry="SubRoutes"
    propsEntry="SubRoutesProps"
    namespace="StandardRouting"
  >
    <ComponentExample
      name="Nested routes"
      rawImport={import("examples/Routing/SubRoutes/NestedRoutesExample?raw")}
    />
  </ComponentDocs>
);

export default RoutingSubRoutes;
